import { Link } from "react-router-dom";
import { Tiles } from "@/components/motion/Tiles";
import { ArrowRight } from "lucide-react";
import { Lines, Reveal } from "@/components/motion/Reveal";

export const PageHeader = ({ eyebrow, title, lines, description, image, crumbs = [], cta }) => (
  <section className="relative overflow-hidden bg-ink pt-32 pb-16 text-white sm:pt-40 sm:pb-24" data-testid="page-header">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" />
      </>
    )}
    <div className="absolute inset-0 blueprint opacity-60" />
    <div className="container-x relative">
      {crumbs.length > 0 && (
        <Reveal y={10} className="mb-6 flex flex-wrap items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-white/50" data-testid="breadcrumbs">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-2">
              <span>/</span>
              {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white/80">{c.label}</span>}
            </span>
          ))}
        </Reveal>
      )}
      {eyebrow && (
        <Reveal y={10} delay={0.1}>
          <p className="eyebrow text-blue-500 flex items-center gap-3"><Tiles />{eyebrow}</p>
        </Reveal>
      )}
      <Lines lines={lines || [title]} className="display mt-4 text-4xl sm:text-5xl lg:text-6xl" delay={0.15} inView={false} />
      {description && (
        <Reveal delay={0.45} className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg">
          <p>{description}</p>
        </Reveal>
      )}
      {cta && (
        <Reveal delay={0.55} className="mt-8">
          <Link to={cta.to} className="btn-primary" data-testid="page-header-cta">
            {cta.label} <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      )}
    </div>
  </section>
);
